import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, FormArray, Validators, ValidationErrors} from '@angular/forms';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import type { ColDef } from "ag-grid-community";
import { Router, ActivatedRoute, Params } from '@angular/router';

import { logisticaModulo as diccionarios} from '../../logistica-diccionario';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { DatosMaestrosService } from 'src/app/services/datos-maestros.service';
import { CentroAlmacen } from '../../../traslado-logist/model/asignacion-centro.model';
import { ITiposViajesShort, ITrackingViajes } from '../../model/modelTracking';
import { LogisticaService } from '../../service/logistica.services';
import { CatalogosLogisticaService } from '../../service/catalogosLogistica.service';
import { TicketAutorizacionTransporteService } from 'src/app/aplicaciones-modulos/balanza/services/ticket-autorizacion-transporte.service';
import SignaturePad from 'signature_pad';
import { UsuariosService } from 'src/app/aplicaciones-modulos/balanza/services/usuarios.service';
import { UsuarioBasculaGaritaService } from 'src/app/aplicaciones-modulos/balanza/services/usuario-bascula-garita.service';
import { ITiposPlanificacion } from '../../model/modelConfiguracional';
import { TrackingConfiguracionService } from '../../service/trackingConfiguracion.services';
import { ITicketAuthTransResp } from 'src/app/aplicaciones-modulos/balanza/modelos/ITicketAuthTransResp';
import { finalize } from 'rxjs/operators';
import { OrdenBalanzaService } from 'src/app/aplicaciones-modulos/balanza/services/orden-balanza.service';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-view-alldoc',
  templateUrl: './view-alldoc.component.html',
  styleUrls: ['./view-alldoc.component.css']
})

export class ViewAlldocComponent implements OnInit {
  public DAT_TITULOS = diccionarios.titulos.garita;
  public GLOBAL_TITULOS = diccionarios.titulos.global;
  public DAT_AG_GRID = diccionarios.agGrid;

  public titleModal   : string;
  public loading      : boolean = false;
  public isCreate     : boolean = true;

  // variables para el grid
  public frameworkComponents: any;
  public columnDefs     : ColDef[] = [];
  public rowData        : any[] = [];
  public rowSelection   : any;
  public gridApi        : any;
  public gridColumnApi  : any;
  public textoBuscar    : string;
  public usarioActual   : any;

  // variables funcionales
  public listCentros    : CentroAlmacen [] = [];
  public listTipos      : ITiposViajesShort  [] = [];
  public listAgencias   : any[] = [];
  public cmbxEstados    : any[] = [];
  public listOpciones   : any[] = [];
  public routear        : "garita";
  public isAprobador    : boolean = false; // true solo si es el aprobador se controla por las rutas importante poner autoritis
  public fechaHoraInicio : any;
  public formFiltro: FormGroup;
  public cmbTiposPlanificacion: ITiposPlanificacion[] = [];
  public proveedorNombreFiltro: string = null;
  public descargandoZip: boolean = false;
  public progresoZip: string = null;


  constructor(
    private fb            : FormBuilder,
    private utilServices  : UtilsService,
    private _catalogos    : CatalogosLogisticaService,
    private logisticaAPI  : LogisticaService,
    private dmaestrosAPI  : DatosMaestrosService,
    private trackingConfiguracional: TrackingConfiguracionService,
    private router        : Router,
    private obalanzaApiService    : OrdenBalanzaService,
    private ttransporteApiService : TicketAutorizacionTransporteService,
    private usuarioBasculaAPI     : UsuarioBasculaGaritaService,
  ) { }

  ngOnInit(): void {
    this.usarioActual = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
    this.rowSelection = 'multiple';
    this.formFiltro = this.fb.group({
      fechaInicio: [null],
      fechaFin: [null],
      proveedorId: [null],
      centroDestino: [null],
      tipo: [null],
    });
    this.cargarCombosFiltro();
    this.cargarGridcomponent();
    this.listar();
  }

  cargarCombosFiltro() {
    this.dmaestrosAPI.getAllCentroLogistico().subscribe((res: any[]) => {
      this.listCentros = (res || []).map((e: any) => {
        e.nombreCentro = e.idCentro + ' - ' + e.nombreCentro;
        return e;
      });
    }, (err) => {
      console.log(err.message);
    });

    this.trackingConfiguracional.getAllTipos().subscribe((res: ITiposPlanificacion[]) => {
      this.cmbTiposPlanificacion = res || [];
    }, (err) => {
      console.log(err.message);
    });
  }

  cargarGridcomponent() {
    this.frameworkComponents = { buttonRenderer: LfsaBotonEditarGridComponent,};
    this.columnDefs = [
      {
        width: 45,
        pinned: 'left',
        checkboxSelection: true,
        headerCheckboxSelection: true,
        suppressMenu: true,
        suppressMovable: true,
        sortable: false,
        filter: false,
        resizable: false,
      },
      ...this._catalogos.getColumnDefs(),
    ];
    this.columnDefs.push(
      { cellRenderer: 'buttonRenderer', initialPinned:"left",width: 120, cellRendererParams: {onClick: this.getTicketGarita.bind(this), label: 'Ticket Garita'} },
      { cellRenderer: 'buttonRenderer', initialPinned:"left",width: 120, cellRendererParams: {onClick: this.getTicketBalanzaEntrada.bind(this), label: 'OB Entrada'}},
      { cellRenderer: 'buttonRenderer', initialPinned:"left",width: 138, cellRendererParams: {onClick: this.getTicketBalanzaSalida.bind(this), label: 'OB Salida'}},
      { cellRenderer: 'buttonRenderer', initialPinned:"left",width: 90, cellRendererParams: {onClick: this.printCheckRegistro.bind(this), label: 'Imprimir'}},
      { cellRenderer: 'buttonRenderer', initialPinned:"left",width: 80, cellRendererParams: {onClick: this.imprimirDoc.bind(this), label: 'T. Salida'}}
    ); 
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  listar(){
    this.rowData = null;
    this.isCreate = false;
    this.logisticaAPI.getAllViajes().subscribe((res) => {
      if(res) this.rowData = res;
    }, (err) => {
      console.log(err.message);
    });
  }

  buscar(){
    const filtros = this.formFiltro?.getRawValue?.() ?? {};
    const hasAny =
      !!String(filtros?.fechaInicio ?? '').trim() ||
      !!String(filtros?.fechaFin ?? '').trim() ||
      !!String(filtros?.proveedorId ?? '').trim() ||
      !!String(filtros?.centroDestino ?? '').trim() ||
      !!String(filtros?.tipo ?? '').trim();

    if (!hasAny) {
      this.listar();
      return;
    }

    this.loading = true;
    this.rowData = null;

    this.logisticaAPI.searchViajesQuery({
      centroDestino: filtros.centroDestino,
      fechaFin: filtros.fechaFin,
      fechaInicio: filtros.fechaInicio,
      proveedorId: filtros.proveedorId,
      tipo: filtros.tipo,
      orderDesc: true,
      page: 0,
      pageSize: 20,
    }).subscribe((res) => {
      this.rowData = res || [];
      this.loading = false;
    }, (err) => {
      this.loading = false;
      console.log(err.message);
    });
  }

  limpiarFiltros(){
    this.formFiltro?.reset({
      fechaInicio: null,
      fechaFin: null,
      proveedorId: null,
      centroDestino: null,
      tipo: null,
    });
    this.proveedorNombreFiltro = null;
    this.listar();
  }
  

  //Acciones del formulario para guardar o retornar
  acciones(event) {
    if (event === 'regresar'){ 
      this.handleBack();
      return;
    }
  }

  private handleBack(): void {
    this.isCreate = false;
    this.ngOnInit();
    this.closeModal();
  }

  openModal() {
    document.getElementById('abrirModal').click();
  }

  closeModal() {
    document.getElementById('cerrarModal').click();
  }

  /** METODOS DE CONSULTAS E IMPRESION */
  printCheckRegistro({rowData}){
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/traslado-logist/reporte-inspeccion/', rowData.idViaje])
    );
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  descargarReportesInspeccionZip(){
    const seleccionados = this.gridApi?.getSelectedRows?.() ?? [];

    const ids: number[] = Array.from(new Set<number>(
      (seleccionados as any[])
        .map((row: any) => Number(row?.idViaje))
        .filter((v: number) => Number.isFinite(v))
    ));

    if (!ids.length) {
      this.utilServices.alertatoastOK('Seleccione al menos un viaje');
      return;
    }

    this.descargandoZip = true;
    this.progresoZip = `Descargando ${ids.length}`;

    this.logisticaAPI.downloadReportesPdfMasivo(ids)
      .pipe(finalize(() => {
        this.descargandoZip = false;
        this.progresoZip = null;
      }))
      .subscribe({
        next: (zipBlob: Blob) => {
          const nombreZip = `reportes_inspeccion_${new Date().toISOString().slice(0, 10)}.zip`;
          saveAs(zipBlob, nombreZip);
          this.utilServices.alertatoastOK('ZIP generado');
        },
        error: (e) => {
          this.utilServices.alertatoastOK('No se pudo generar el ZIP');
          console.log(e);
        }
      });
  }

  getTicketGarita({rowData}){
    const ticketGarita = rowData.garitaTicket

    if(ticketGarita <= 0 || ticketGarita == undefined){
       this.utilServices.alertatoastOK("No hay ticket de garita para imprimir");
       return;
    }
    this.ttransporteApiService.obtenerPorId(ticketGarita).subscribe((res) => {
      console.log("ticket garita", res);
      this.printTicketGarita(res);
    }, (err) => { 
      console.log(err.message); 
    });    
  }

  ticketGaritaD: ITicketAuthTransResp;
  printTicketGarita(ticket){
    this.loading = true;
    this.ttransporteApiService.imprimir(ticket).subscribe(
      resp => {
        console.log("Imprimir resp", resp)
        if (resp) {
          this.utilServices.descargarArchivo("ticket-autorización-transporte-" + ticket.idAuthTransp + ".pdf", resp);
          this.loading = false;
          return;
        }
        this.utilServices.mensajeErroToast('No se pudo imprimir correctamente.');
        this.loading = false;
      },
      error => {this.loading = false;}
    );
  }

  //ORDEN DE BALANZA
  viajeSelected;
  getTicketBalanzaEntrada({rowData}){
    this.viajeSelected = rowData;
    this.getTicketBalanza(true);
  }

  getTicketBalanzaSalida({rowData}){
    this.viajeSelected = rowData;
    this.getTicketBalanza(false);
  }

  getTicketBalanza(isEntrada: boolean){
    const ticketBalanza = this.viajeSelected.balanzaTicket;

    if(ticketBalanza <= 0 || ticketBalanza == undefined){
       this.utilServices.alertatoastOK("No hay ticket de balanza para imprimir");
       return;
    }

    this.obalanzaApiService.obtenerPorId(ticketBalanza).subscribe((res) => {
      if(res.pesoIn == null || res.pesoOut == null){
        this.utilServices.alertatoastOK("Orden de balanza sin registo de peso para imprimir");
        return;
      }
      
      if(isEntrada) this.printCapturaEntrada(res);
      if(!isEntrada) this.printCapturaSalida(res);

    }, (err) => { 
      console.log(err.message); 
    });

  }

  printCapturaEntrada(ticketBalanza) {
    this.obalanzaApiService.imprimirCapturaEntrada(ticketBalanza).subscribe(
      (resp) => {
        if (resp) {
          let name = "Orden-Balanza-entrada-" + ticketBalanza.idOrden + ".pdf";
          this.utilServices.descargarArchivo(name, resp);
          return;
        }
        this.utilServices.mensajeErroToast('No se pudo imprimir correctamente.');
      },
      (error) => {
        console.log(error);
      }
    );
  }

  printCapturaSalida(ticketBalanza) {
    this.obalanzaApiService.imprimirCapturaSalida(ticketBalanza).subscribe(
      (resp) => {
        if (resp) {
          let name = "Orden-Balanza-salida-" + ticketBalanza.idOrden + ".pdf";
          this.utilServices.descargarArchivo(name, resp);
          return;
        }
        this.utilServices.mensajeErroToast('No se pudo imprimir correctamente.');
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getProveedor(){
    const id = String(this.formFiltro.get('proveedorId')?.value ?? '').trim();
    this.proveedorNombreFiltro = null;
    if (!id) {
      return;
    }
    this.dmaestrosAPI.getProveedorByID(+id).subscribe((res) => {
      if (res) {
        this.proveedorNombreFiltro = res?.nombre ?? null;
      } else {
        this.utilServices.alertatoastOK("No se encontró registro de proveedor");
      }
    }, (err) => {
      console.log(err.message);
    });
  }

  proveedorSeleccionado(proveedor: any) {
    console.log('Proveedor seleccionado:', proveedor);
    this.formFiltro.get('proveedorId')?.setValue(proveedor?.idProveedor);
    this.proveedorNombreFiltro = proveedor?.nombre ?? null;
  }

  downloadDataCsv() {
    let data: any = [];
    let name: string = "datosPlanificacion.csv";

    let cabecera: any[] = [[
      'TIPO_PLANIFICACION_ID',
      'TIPO_PLANIFICACION_NOMBRE',
      'GARITA_TICKET',
      'BALANZA_TICKET',
      'ESTADO',
      'CHOFER_NOMBRE',
      'CHOFER_CELULAR',
      'PLACA',
      'PROVEEDOR_NOMBRE',
      'CENTRO_ORIGEN_NOMBRE',
      'CENTRO_DESTINO_NOMBRE',
      'CLIENTE_NOMBRE',
      'FURGON',
      'ID_VIAJE',
      'FECHA_PLANIFICACICON',
      'CREADO_POR'
    ]];

    let clonData = this.rowData.map((x) => Object.assign({}, x));

    clonData.forEach((e) => {
        data.push(
          {
            tipoPlanificacionId : e.tipo,
            tipo                : e.tipoPlanificacion.nombre,
            garitaTicket        : e.garitaTicket,
            balanzaTicket       : e.balanzaTicket,
            estado              : e.estado,
            choferNombre        : e.choferNombre,
            choferCelular       : e.choferCelular,
            placa               : e.placa,
            proveedorNombre     : e.proveedorNombre,
            centroOrigenNombre  : e.centroOrigenNombre,
            centroDestinoNombre : e.centroDestinoNombre,
            clienteNombre       : e.clienteNombre,
            furgon              : e.furgon,
            idViaje             : e.idViaje,
            fechaLlegada        : e.fechaLlegada,
            creadoPor           : e.creadoPor,
          }
        );
    });

    this.utilServices.exportCSV(cabecera, data, name);
    this.utilServices.mensajeOKToast('El archivo csv se exportó correctame.');
  }

  imprimirDoc({rowData}){
    this.logisticaAPI.downloadReporteSalida(rowData.idViaje, this.usarioActual.login2).subscribe({
      next: (blob: Blob) => {
        const blobUrl = URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = blobUrl;
        anchor.download = `reporte_salida_${rowData.idViaje}.pdf`;
        anchor.click();
        setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
      },
      error: (err) => {
        const message = err?.message || 'No se pudo generar el PDF';
        this.utilServices.mensajeErroToast(message, 3000);
      }
    });
  }

}
